import type { Action } from 'redux';
import type { Allowance } from '../../../../../../shared/types';
import NotificationActions from '../../../../main/actions/NotificationActions';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const API_VERSION_PATH = '/v1' as const;
const ENDPOINT_PATH = '/status/social-image' as const;
const ERROR_MESSAGE = 'Failed to fetch social image allowance.' as const;
const ERROR_TYPE = 'error' as const;

const FetchSocialImageAllowance = new ReduxAsyncAction<'FETCH_SOCIAL_IMAGE_ALLOWANCE', string, Allowance>(
  'FETCH_SOCIAL_IMAGE_ALLOWANCE'
);

FetchSocialImageAllowance.registerRequest(async (): Promise<Allowance> => {
  try {
    const { data } = await dash_api.get(`${API_VERSION_PATH}${ENDPOINT_PATH}`);

    return data;
  } catch (error) {
    NotificationActions.showNotification(ERROR_MESSAGE, ERROR_TYPE);

    throw error;
  }
});

export const FETCH_SOCIAL_IMAGE_ALLOWANCE = FetchSocialImageAllowance.actionNamespaceConstants;
export const fetchSocialImageAllowance = FetchSocialImageAllowance.request;

export type FetchSocialImageAllowanceResponseAction = Action<typeof FETCH_SOCIAL_IMAGE_ALLOWANCE.response> & {
  data: Allowance;
};
